import { z } from 'zod';

// Folder structure for templates
export const folderStructureItemSchema: z.ZodType<{
  name: string;
  children?: { name: string; children?: unknown[] }[];
}> = z.object({
  name: z.string(),
  children: z.lazy(() => z.array(folderStructureItemSchema)).optional(),
});

export type FolderStructureItem = z.infer<typeof folderStructureItemSchema>;

// Template schema
export const templateSchema = z.object({
  id: z.string(),
  userId: z.string().nullable(),
  name: z.string(),
  description: z.string().nullable(),
  structure: z.array(folderStructureItemSchema),
  isSystem: z.boolean(),
  createdAt: z.string(),
  updatedAt: z.string(),
});

export type Template = z.infer<typeof templateSchema>;

// Request schemas
export const createTemplateRequestSchema = z.object({
  name: z.string().min(1).max(100),
  description: z.string().max(500).optional(),
  structure: z.array(folderStructureItemSchema),
});

export type CreateTemplateRequest = z.infer<typeof createTemplateRequestSchema>;

export const applyTemplateRequestSchema = z.object({
  clientId: z.string().optional(),
  projectId: z.string().optional(),
  parentFolderId: z.string().optional(),
});

export type ApplyTemplateRequest = z.infer<typeof applyTemplateRequestSchema>;

// Response schemas
export const templatesResponseSchema = z.object({
  templates: z.array(templateSchema),
});

export type TemplatesResponse = z.infer<typeof templatesResponseSchema>;

export const applyTemplateResponseSchema = z.object({
  success: z.boolean(),
  foldersCreated: z.number(),
  folders: z.array(z.object({
    id: z.string(),
    name: z.string(),
    path: z.string(),
  })),
});

export type ApplyTemplateResponse = z.infer<typeof applyTemplateResponseSchema>;
